$(document).ready(function(){
  var slider = $(".image_with_text_slider").owlCarousel({
      loop:true, 
      responsiveClass:true,
      autoplay: true, 
      dots:true ,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      items:1 
  }); 
   
  $(".image_with_text_slider").on('wheel', function(e) {
    if (e.originalEvent.deltaY > 0) { 
      slider.trigger('next.owl.carousel');
    } else { 
      slider.trigger('prev.owl.carousel');
    }
    e.preventDefault();  
  });
  $(".multi_image_slider").owlCarousel({
      loop:true, 
      responsiveClass:true,
      autoplay: true, 
      dots: false,
      nav: true,
      items:1 ,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
  }); 

  $(".large_image_slider").owlCarousel({
      loop:true, 
      responsiveClass:true,
      autoplay: true, 
      dots: false,
      nav: true,
      items:1 ,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
  }); 
/*
  function mainDoubbleSlide() {
      $("#mainDoubbleSlide .photos>*").each(function () {
          $(this).find(".photo").length;
          var n = $(this);
          $(this).find(".photo:nth-child(1) .mask").addClass("slide"),
              setInterval(function () {
                  var e;
                  (e = n).find(".photo:nth-child(2) .mask").addClass("slide"),
                      setTimeout(function () {
                          e.find(".photo:nth-child(1) .mask").removeClass("slide"), e.find(".photo:nth-child(1)").appendTo(e);
                      }, 2e3);
              }, 11e3);
      });
  }
*/
function mainDoubbleSlide() {
    $("#mainDoubbleSlide .photos>*").each(function () {
        var n = $(this);
        var photoCount = n.find(".photo").length;

        n.find(".photo:nth-child(1) .mask").addClass("slide");

        setInterval(function () {
            var currentPhoto = n.find(".photo:nth-child(1)");
            currentPhoto.find(".mask").removeClass("slide");
            currentPhoto.appendTo(n);
            n.find(".photo:nth-child(1) .mask").addClass("slide");
        }, 11000);
    });
}
  if ($('#mainDoubbleSlide').length) {
      mainDoubbleSlide();
  }
  
});
// instagram 

 

  window.addEventListener('load', function () {
    // Delay execution by 2 seconds (2000 milliseconds)
    setTimeout(function () {
      const slider = document.querySelector('.instagram-grid-container');
      
      if (slider) {
        const clones = slider.innerHTML; // Clone all <li> elements
        
        // Append clones to the end of the container
        slider.innerHTML += clones;
        //console.log(clones); // Log cloned content to the console
      }
    }, 2000); // 2-second delay
  });

  window.addEventListener('load', function () {
    // Delay execution by 2 seconds (2000 milliseconds)
    setTimeout(function () {
      const slider = document.querySelector('.instafeed-new-layout-wrapper');
      
      if (slider) {
        const clones = slider.innerHTML; // Clone all <li> elements
        
        // Append clones to the end of the container
        setTimeout(function(){
        slider.innerHTML += clones;
        },8000); 
        //console.log(clones); // Log cloned content to the console
      }
    }, 2000); // 2-second delay
  });
const TouchHoverEffect = {
  init: function() {
    // Find all elements with the .overlay_on_image class
    this.elements = document.querySelectorAll('.overlay_on_image');

    // Check if any elements exist with the .overlay_on_image class
    if (this.elements.length > 0) {
      // Bind touchstart and touchend event handlers if elements are found
      this.bindEvents();
    } 
  },

  bindEvents: function() {
    this.elements.forEach(element => {
      element.addEventListener('touchstart', this.handleTouchStart.bind(this));
      element.addEventListener('touchend', this.handleTouchEnd.bind(this));
    });
  },

  handleTouchStart: function(event) {
    // Add the 'touch' class when the element is touched
    event.target.classList.add('touch');
  },

  handleTouchEnd: function(event) {
    // Remove the 'touch' class after a small delay (optional)
    setTimeout(() => {
      event.target.classList.remove('touch');
    }, 300); // Adjust delay time as needed
  }
};

// Ensure the script runs after the document is fully loaded
document.addEventListener('DOMContentLoaded', function() {
  TouchHoverEffect.init();
});
